/**
 * @generated SignedSource<<2e465f54490c76f74b32f29c3948bc41>>
 * @relayHash b2d0a7a52dcfc0def29d87a1ae1deedd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8aa006b52c3bed531cf7807c7422a07309a35fca4cc3a50e7a6ab6f0fd7c74be

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubDetailsPageQuery } from './ServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8aa006b52c3bed531cf7807c7422a07309a35fca4cc3a50e7a6ab6f0fd7c74be",
    "metadata": {},
    "name": "ServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
